import { createSlice } from '@reduxjs/toolkit';

const initialState = {
	logoPaths: []
};

const groupLogosSlice = createSlice({
	name: 'groupLogos',
	initialState,
	reducers: {
		groupLogosSet(state, action) {
			return {
				...state,
				logoPaths: action.payload
			};
		}
	}
});

export const { groupLogosSet } = groupLogosSlice.actions;

export default groupLogosSlice.reducer;
